import { useSelector } from 'react-redux';
import { PQR_DETAIL } from '../../../../../routes/paths';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import { Table } from '../../../../components/general/table';
import { usePqrList } from './hook';
import { PqrListProps } from './props';
import { RootState } from '../../../../../redux/store';

export const PqrList = ({ filters, onSelectionModel }: PqrListProps) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const {
        columns,
        rows,
        loading,
        page,
        pageSize,
        paginator,
        total,
        handleSelectionChange,
    } = usePqrList(filters, onSelectionModel);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${PQR_DETAIL}/${item.row.id}`, '_blank')
            }
            {...(!isOnlyViewProfile(type) || type === 'cliente'
                ? {
                    checkboxSelection: true,
                }
                : {})}
            onRowSelectionModelChange={handleSelectionChange}
        />
    );
};
